export default __webpack_public_path__ + "media/src/usersite/images/header/sns_banners/sp_sns_line-b21311220850facaaf8af537a72fc697.png";